import axios from 'services/axios'

export const fetchLoginUrl = axios.get('auth/get-login-url')
